import React from 'react'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { SurgicalOrderResume } from 'presentation/secretary/pages/SurgicalOrderResume'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteLoadSurgicalOrder } from 'service/usecases/load-surgical-order/remote-load-surgical-order'
import { RemoteLoadSurgicalOrderDocument } from 'service/usecases/load-surgical-order-document/load-upload-surgical-order-document'
import { RemoteUpdateSurgicalOrderRegenerateGuides } from 'service/usecases/update-surgical-order-regenerate-guides/remote-update-surgical-order-regenerate-guides'
import { HealthInsuranceRepository } from 'repository/repositories/health-insurance/health-insurance-repository'
import { RemoteLoadHealthInsurancePlans } from 'service/usecases/load-health-insurance-plans/remote-load-health-insurance-plans'

export default function makeHospitalOrderAbstract() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const healthInsurancesRepository = new HealthInsuranceRepository(
    apiRepository
  )
  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)
  const loadSurgicalOrder = new RemoteLoadSurgicalOrder(surgicalOrderRepository)
  const loadSurgicalOrderDocument = new RemoteLoadSurgicalOrderDocument(
    surgicalOrderRepository
  )
  const updateSurgicalOrderRegenerateGuides =
    new RemoteUpdateSurgicalOrderRegenerateGuides(surgicalOrderRepository)

  const loadHealthInsurances = new RemoteLoadHealthInsurancePlans(
    healthInsurancesRepository
  )
  return (
    <SurgicalOrderResume
      loadOrder={loadSurgicalOrder}
      loadSurgicalOrderDocument={loadSurgicalOrderDocument}
      updateSurgicalOrderRegenerateGuides={updateSurgicalOrderRegenerateGuides}
      loadHealthInsurance={loadHealthInsurances}
    />
  )
}
